export default class ApprovedShipperLicenses {
  constructor (options = {}) {
    this.model = 'ApprovedShipperLicenses'

    this.id = options.id
    this.org_id = options.org_id
    this.shipper_id = options.shipper_id

    // Ship-to address association
    this.license_for_shipping_address = options.license_for_shipping_address
    this.street_1 = options.street_1
    this.street_2 = options.street_2
    this.city = options.city
    this.state = options.state
    this.zip = options.zip

    // Establishment license
    this.establishment_license_number = options.establishment_license_number
    this.establishment_license_category = options.establishment_license_category
    this.establishment_license_issue_date = options.establishment_license_issue_date
    this.establishment_license_expiration = options.establishment_license_expiration
    this.establishment_license_amended_date = options.establishment_license_amended_date

    // DRC
    this.drc_number = options.drc_number
    this.drc_category = options.drc_category
    this.drc_issue_date = options.drc_issue_date
    this.drc_expiration = options.drc_expiration
    this.drc_amended_date = options.drc_amended_date

    // License doc info
    this.license_docs = options.license_docs || {}

    // Copy of shipper location record
    this.data = options.data

    // Changes from previous approval
    this.changed_info = options.changed_info || {}

    // Auditing
    this.approved_by = options.approved_by
    this.approved_at = options.approved_at
    this.created_at = options.created_at
    this.updated_at = options.updated_at
  }
}
